import React, { useState, useEffect, useContext } from 'react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import Chat from 'components/BiteAI/Chat';
// import Files from 'components/BiteAI/Files';
import AIChatAPI from 'api/AIChatAPI';
import io from 'socket.io-client';
import { useSnackbar } from 'notistack';
import { GlobalContext } from 'providers/GlobalProvider';
import SubscribeModal from '../../components/SubscribeModal';
import { Player } from '@lottiefiles/react-lottie-player';
import { Typography } from '@mui/material';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';

const BiteAI: React.FC<any> = (props: any) => {
  // const [ files, setFiles ] = useState([]);
  const [ isTyping, setIsTyping ] = useState(false);
  const [ statusText, setStatusText ] = useState('');
  const [ socketId, setSocketId ] = useState('');
  const [ threadId, setThreadId ] = useState(null);
  const [ messages, setMessages ] = useState([
    {
      message:
        'Hello, I\'m Biscuit, an AI powered assistant, customized to solve complex compliance questions.<br>Please specify in your search / prompt. If you would like me to search BITE Data, or the Web.<br>You can say \'Please search BITE for XYZ\' or \'Please search the web for XYZ\'',
      sentTime: 'just now',
      sender: 'ChatGPT',
    },
  ]);
  const { enqueueSnackbar } = useSnackbar();
  const { cur_user } = useContext(GlobalContext);
  const [ userHasBiteGPT, setUserHasBiteGPT ] = useState(false);
  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] =
    useState<string>('');
  const [ activeSub, setActiveSub ] = useState(false);

  const checkForBiteGPTAndTrial = () => {
    if (cur_user.selected_team?.attributes?.tier?.includes('enterprise')) {
      setUserHasBiteGPT(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (sub.metadata.moduleName === 'BITE Enterprise') {
              setActiveSub(true);
            }
          });
        }
      });
    }
  };

  useEffect(() => {
    if (props.location.state) {
      const { input } = props.location.state;
      if (input && socketId) {
        handleSendClick(input);
      }
    }
  }, [ props.location.state, socketId ]);

  useEffect(() => {
    checkForBiteGPTAndTrial();
  }, [ activeSub ]);

  useEffect(() => {
    const socket = io({ path: '/api/socket.io' });

    const socketConnection = socket.connect();
    socketConnection.on('connect', () => {
      setSocketId(socketConnection.id);
    });

    socket.on('status', (status: string) => {
      setStatusText(status);
    });

    socket.on('message', (message: string) => {
      const chatGPTResponse = {
        message: message,
        sender: 'ChatGPT',
      };
      setMessages((prevMessages: any) => [ ...prevMessages, chatGPTResponse ]);
    });

    // fetchFiles();
  }, []);

  /* const fetchFiles = async () => {
    try {
      const resp = await AIChatAPI.getFiles();

      if(resp?.success){
        setFiles(resp.result);
        return resp.result;
      }else{
        throw new Error(resp?.result);
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error fetching files: ' + error, { variant: 'error', persist: true });
    }
  };*/

  const handleSendClick = async(message: string) => {
    const newMessage = {
      message: message,
      direction: 'outgoing',
      sender: 'user',
    };

    setMessages((prevMessages: any) => [ ...prevMessages, newMessage ]);
    setIsTyping(true);

    try {
      const response = await sendMessage([ ...messages, newMessage ]);
      const isSuccess = response.success;
      const thread_id = response.thread_id;
      if (threadId === null) {
        setThreadId(thread_id);
      }
      if (!isSuccess) {
        throw response.error_msg;
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(`Error processing message: ${error}`, {
        variant: 'error',
        persist: true,
      });
    } finally {
      setIsTyping(false);
    }
  };

  const sendMessage = async(chatMessages: any) => {
    const resp = await AIChatAPI.sendMessage({
      message: chatMessages[chatMessages.length - 1].message,
      thread_id: threadId,
      socket_id: socketId,
    });

    if (resp?.success) {
      return resp.result;
    }
    throw new Error(resp?.result);
  };

  /* const handleAttachClick = async (e: any) => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.onchange = async (e: any) => {
      const raw_file = e.target.files[0];
      const formData = new FormData();
      formData.append('file', raw_file);
      const resp = await AIChatAPI.uploadFile(formData);
      if(resp?.success) {
        fetchFiles();
      } else {
        console.error(resp);
        enqueueSnackbar('Error uploading file', { variant: 'error', persist: true });
      }
    };
    fileInput.click();
  };

  const handleDeleteFile = async (file_id: string) => {
    const resp = await AIChatAPI.deleteFile(file_id);
    if(resp?.success){
      fetchFiles();
    }else{
      console.error(resp);
      enqueueSnackbar('Error deleting file', { variant: 'error', persist: true });
    }
  };*/

  return (
    <ModuleHeaderLayout
      title='Ask'
      helpContent={
        'Biscuit will provide more direct and clear responses to detailed questions. Having issues? contact the BITE Team or visit the OpenAI Status link below to check the current status of OpenAI.'
      }
    >
      {activeSub && !userHasBiteGPT ? (
        <div className='no-license-modal'>
          <Player
            autoplay
            loop
            src='https://lottie.host/3c23c1ad-7f71-4e3d-8f19-69154715dbdc/SdWWjCmU1J.json'
            style={{ width: '20%' }}
          ></Player>
          <Typography
            variant='h6'
            className='text-white'
            style={{
              fontSize: '20px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
            }}
          >
            You need an assigned license to access this module
          </Typography>
          <Typography
            variant='h6'
            style={{
              fontSize: '18px',
              fontWeight: 700,
              lineHeight: '24px',
              letterSpacing: '0.15px',
              marginTop: '20px',
              color: '#BDBEC1',
            }}
          >
            Visit Account &gt; Users &gt; to assign an available license to your
            user or contact your team admin
          </Typography>
        </div>
      ) : !userHasBiteGPT ? (
        <SubscribeModal
          name='Ask'
          description='Solve your questions related to trade data with Buscuit'
          price={59}
          curUser={cur_user}
          stripeTeam={matchedTeamWithStripe}
          activeSub={activeSub}
        />
      ) : (
        <></>
      )}
      <div className={`${!userHasBiteGPT ? 'os-iframe-blur' : ''}`}>
        <a
          className='status-link'
          href='https://status.openai.com/'
          target='_blank'
          rel='noreferrer'
        >
          OpenAI Status
        </a>
        <Chat
          messages={messages}
          isTyping={isTyping}
          statusText={statusText}
          // handleAttachClick={handleAttachClick}
          handleSendClick={handleSendClick}
        />
      </div>
      {/* <Files
        files={files}
        handleDeleteFile={handleDeleteFile} />*/}
    </ModuleHeaderLayout>
  );
};
export default BiteAI;
